<style src="vue-select/dist/vue-select.css"></style>
<style>
	.table-hover {
		width: 100%;
		table-layout: fixed;
	}

	.table-sm {
        font-size: 14px;
    }
</style>

<template>
	<section class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header">
							<h3 class="card-title">Overview Kas (Arus Kas)</h3>
							
						</div>
                        
						<div class="card-body table-responsive p-2">
              <div class="col-sm-12 col-md-12">
                <KantorCabang v-model="filter.kantor" label="Semua Cabang" @input="onFilterChange"
                class="custom-input" />
              </div>
              <div class="col-sm-12 col-md-12">
                  <table class="table table-borderless table-sm" style="border: 0px important;font-size: 15px;font-weight: 500;" >
                      <tbody>
                          
                          <tr>
                              <td style="width: 14%;">Total Tagihan</td>
                              <td style="width: 10px;">:</td>
                              <td style="width: 240px">{{formatRupiah(header.total)}}</td>
                              <td style="width:16%">Total Invoice Overdoe</td>
                              <td style="width: 10px;">:</td>
                              <td>{{formatRupiah(header.total_overdoe)}}</td>
                          </tr>
                          <tr>
                              <td>Paid Invoice</td>
                              <td>:</td>
                              <td>{{formatRupiah(header.paid)}}</td>
                              <td>Paid Overdoe</td>
                              <td>:</td>
                              <td>{{formatRupiah(header.paid_overdoe)}}</td>
                          </tr>
                          <tr>
                              <td>Unpaid Invoice</td>
                              <td>:</td>
                              <td>{{formatRupiah(header.unpaid)}}</td>
                              <td>UnPaid Overdoe</td>
                              <td>:</td>
                              <td>{{formatRupiah(header.unpaid_overdoe)}}</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
              <div class="col-sm-12 col-md-12">
                <div style="font-size: 18px;font-weight: bold;display: flex;justify-content: end;">Saldo Awal Bulan {{namaBulanSekarang}} : {{formatRupiah(header.opening_balance)}}</div>
                  <v-data-table
                      :headers="headers"
                      :items="usersWithSaldo"
                      :loading="loading"
                      :items-per-page="pagination.itemsPerPage"
                      :page.sync="pagination.page"
                      :server-items-length="totalItems"
                      :footer-props="{ itemsPerPageOptions: [50, 100, 200] }"
                      @update:page="fetchUsers"
                      @update:items-per-page="changeItemsPerPage"
                  >
                     
                      <!-- Slot row: custom seluruh <tr> -->
                    <template #item="{ item, index }">
                      <tr :class="item.debit > 0 ? 'row-success' : 'row-error'">
                        <td class="text-center"> {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}</td>
                        <td>{{ item.keterangan }}</td>
                        <td class="text-right">{{ formatRupiah(item.debit) }}</td>
                        <td class="text-right">{{ formatRupiah(item.kredit) }}</td>
                        <td class="text-right">{{ formatRupiah(item.saldo) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
              </div>
						</div>
						
					</div>
					<!-- /.card -->
				</div>
			</div>			
		</div>
	</section>
</template>

<script>

import { formatRupiah } from '../../helpers/format'
import KantorCabang from '../../base-components/KantorCabang.vue'
export default {
  components: {
    KantorCabang,
  },
  data() {
    return {
      filter: {
        kantor: null
      },
      user: this.$gate.user,
      users: [],
      totalItems: 0,
      loading: false,
      header:{
        total: 0,
        paid:0,
        unpaid:0,
        expense:0,
        ending_balance:0,
        opening_balance:0,
        unpaid_overdoe:0,
        paid_overdoe:0,
        total_overdoe:0
      },
      pagination: {
        page: 1,
        itemsPerPage: 100
      },
      headers: [
        { text: 'No', value: 'no',sortable: false, width: '30px', align: 'center' },
        { text: 'Keterangan', value: 'keterangan',sortable: true, width: '50%' },
        { text: 'Debet', value: 'debit',sortable: true, class: 'text-right', width: '100px' },
        { text: 'Kredit', value: 'kredit', sortable: true, class: 'text-right', width: '100px' },
        { text: 'Balance', value: 'saldo', sortable: true, class: 'text-right', width: '100px' }
      ]
    }
  },
  computed: {
    usersWithSaldo() {
      let saldo = Number(this.header.opening_balance) || 0;
      return this.users.map((item) => {
        const debit = Number(item.debit) || 0;
        const kredit = Number(item.kredit) || 0;
        saldo += debit - kredit;
        return {
          ...item,
          saldo
        };
      });
    },
    namaBulanSekarang() {
      const bulanIndo = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];
      const now = new Date();
      return bulanIndo[now.getMonth()];
    }
  },
  
  mounted() {
    this.fetchUsers()
  },
  methods: {
    onFilterChange() {
      console.log('periode berubah:', this.filter.periode);
      this.pagination.page = 1;
      this.fetchUsers();
    },
    formatRupiah,
    async fetchUsers() {
      this.loading = true
      try {
        const res = await axios.get('api/keuangan/arus_kas', {
          params: {
            page: this.pagination.page,
            per_page: this.pagination.itemsPerPage,
            kantor_id: this.filter.kantor?.id || null
          }
        })

        this.users = res.data.kas.data;
        this.totalItems = res.data.kas.total;
        this.header = res.data.header;
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    changeItemsPerPage(perPage) {
      this.pagination.itemsPerPage = perPage
      this.pagination.page = 1
      this.fetchUsers()
    }
  }
}
</script>

<style scoped>
::v-deep .row-success {
  background-color: #e6ffed !important;
}
::v-deep .row-error {
  background-color: #ffeaea !important;
}
</style>